// extracted by mini-css-extract-plugin
module.exports = {"alert":"alert___3JY1T"};